<template>
  <div id="filebox">
    <i-box>
      <span slot="title">
        <h5>Files</h5>
      </span>
      <span slot="content">
        <el-tabs v-model="activeTabName">
          <el-tab-pane label="My Files" name="myFiles">
            <filebox-table
              v-loading="loadingMyFiles"
              element-loading-text="Loading your files..."
              :files="myFiles"
              :icons="icons"
            ></filebox-table>
          </el-tab-pane>

          <el-tab-pane label="Company Files" name="companyFiles">
            <filebox-table
              v-loading="loadingCompanyFiles"
              element-loading-text="Loading company files..."
              :files="companyFiles"
              :icons="icons"
            ></filebox-table>
          </el-tab-pane>
        </el-tabs>
      </span>
    </i-box>
  </div>
</template>

<script>
import FileboxTable from '@/components/filebox/FileboxTable';
import IBox from '@/components/common/IBox';

export default {
  name: 'FileboxList',
  components: { FileboxTable, IBox },
  data: () => ({
    activeTabName: 'myFiles',
  }),
  props: {
    myFiles: {
      type: Array,
      default: () => [],
      required: true,
    },
    companyFiles: {
      type: Array,
      default: () => [],
      required: true,
    },
    loadingMyFiles: {
      type: Boolean,
      default: false,
    },
    loadingCompanyFiles: {
      type: Boolean,
      default: false,
    },
    icons: {
      type: Object,
      default: () => {},
      required: true,
    },
  },
};
</script>


// WEBPACK FOOTER //
// FileboxList.vue?d2b18392